import CompleteDeliveryNotesChart from "./CompleteDeliveryNotesChart";
import IncompleteDeliveryNotesChart from "./IncompleteDeliveryNotesChart";
import MissingImagesChart from "./MissingImagesChart";
import UnsignedEINChart from "./UnsignedEINChart";
import UnsignedProductLoadedChart from "./UnsignedProductLoadedChart";
import UnsignedProductMatchChart from "./UnsignedProductMatchChart";
import UnsignedSalesOrdersChart from "./UnsignedSalesOrdersChart";
import {
	VCol,
	VRow
} from "vuetify/lib";

export default {
	name: "DeliveryNotesReportCharts",

	props: {
		item: Object,
		items: Array
	},

	render() {
		return <VRow class="k-charts" justify="center">
			<VCol class="k-chart-wrapper" cols={12} md={6}>
				<CompleteDeliveryNotesChart
					item={this.item}
					items={this.items}
				></CompleteDeliveryNotesChart>
			</VCol>

			<VCol class="k-chart-wrapper" cols={12} md={6}>
				<IncompleteDeliveryNotesChart
					item={this.item}
					items={this.items}
				></IncompleteDeliveryNotesChart>
			</VCol>

			<VCol class="k-chart-wrapper" cols={12} md={6}>
				<UnsignedSalesOrdersChart
					item={this.item}
					items={this.items}
				></UnsignedSalesOrdersChart>
			</VCol>

			<VCol class="k-chart-wrapper" cols={12} md={6}>
				<UnsignedEINChart
					item={this.item}
					items={this.items}
				></UnsignedEINChart>
			</VCol>

			<VCol class="k-chart-wrapper" cols={12} md={6}>
				<UnsignedProductMatchChart
					item={this.item}
					items={this.items}
				></UnsignedProductMatchChart>
			</VCol>

			<VCol class="k-chart-wrapper" cols={12} md={6}>
				<UnsignedProductLoadedChart
					item={this.item}
					items={this.items}
				></UnsignedProductLoadedChart>
			</VCol>

			<VCol class="k-chart-wrapper" cols={12} md={6}>
				<MissingImagesChart
					item={this.item}
					items={this.items}
				></MissingImagesChart>
			</VCol>
		</VRow>;
	}
};
